/* eslint-disable no-underscore-dangle */
import { useCallback } from 'react';
import { useNativeAppStore } from '@namespace/native-app';

export const useSmarticoSuspendCallback = () => {
  const { nativeAppConfig } = useNativeAppStore();

  const { smartico: nativeSmarticoConfig } = nativeAppConfig;

  const { suspendPopups = false, suspendInbox = false } =
    nativeSmarticoConfig || {};

  const cb = useCallback(
    (popups, inbox) => {
      window._smartico?.suspendPopups?.(suspendPopups || popups);
      window._smartico?.suspendInbox?.(suspendInbox || inbox);
    },
    [suspendPopups, suspendInbox]
  );

  return cb;
};
